/* eslint-disable react/jsx-key */
import React, { Component } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import RbaMapComponent from "../Components/RbaMapComponent";
import YouTubePlayer from "../Components/YoutubePlayer";
import Footer from "../Components/Footer";
import MainBanner from "../Components/MainBanner";
import ContactForm from "../Components/ContactForm";
import { Link } from "react-router-dom";
import BestDeals from "../Components/BestDeals";
export default class AnaSayfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      properties: [],
      featured: [],
    };
  }
  getIlan() {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/ilan/get-preview/?p=1&filter=Tümü`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Veri alınamadı.");
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ properties: data["data"] });
      })
      .catch((err) => {});
  }

  getFeatured = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ilan/get-preview-featured`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Veri alınamadı.");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);

        this.setState({ featured: data["data"] });
      })
      .catch((err) => {});
  };
  PropertyListings = () => {
    return (
      <div className="row properties-box">
        {this.state.properties.map((property) => (
          <div
            key={property.id}
            className="col-lg-4 col-md-6 mb-30 properties-items adv"
          >
            <div className="item">
              <Link to={`/ilan-detay?id=${property.id}`}>
                <img
                  src={`${process.env.REACT_APP_API_URL}/api/files/?filepath=${property.image[0]}`}
                  alt={property.title}
                />
              </Link>
              <span className="category">{property.type}</span>
              <h6>₺{property.price}</h6>
              <h4>
                <Link to={`/ilan-detay?id=${property.id}`}>
                  {property.title}
                </Link>
              </h4>
              <ul>
                {property.typicalFeatures &&
                  (Array.isArray(property.typicalFeatures)
                    ? property.typicalFeatures
                        .slice(0, 3)
                        .map((item, index) => {
                          const parts = item.split(":");

                          return parts.length === 2 ? (
                            <li key={index}>
                              {parts[0]} : <span>{parts[1]}</span>
                            </li>
                          ) : null;
                        })
                    : // Eğer typicalFeatures bir stringse, onu split edip işleyelim
                      property.typicalFeatures
                        .split(",")
                        .slice(0, 3)
                        .map((item, index) => {
                          const parts = item.split(":");

                          return parts.length === 2 ? (
                            <li key={index}>
                              {parts[0]} : <span>{parts[1]}</span>
                            </li>
                          ) : null;
                        }))}

                <li>
                  📍 Konum :
                  <span>{` ${property.il}  ${property.ilce}  ${property.mahalle}`}</span>
                </li>
              </ul>
              <div className="main-button">
                <Link to={`/ilan-detay?id=${property.id}`}>İlanı İncele</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Format phone number as user types
  handlePhoneChange = (e) => {
    const input = e.target.value;

    // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, "");

    // Limit to 10 digits (Turkish mobile numbers without country code)
    const truncated = digitsOnly.substring(0, 10);

    // Format the phone number as user types (XXX XXX XX XX)
    let formatted = "";
    if (truncated.length > 0) {
      formatted = truncated.replace(
        /(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/,
        (_, p1, p2, p3, p4) => {
          let result = p1;
          if (p2) result += " " + p2;
          if (p3) result += " " + p3;
          if (p4) result += " " + p4;
          return result;
        }
      );
    }

    this.setState({ phone: formatted });
  };

  // Validate form before submission
  handleSubmit = (e) => {
    e.preventDefault();

    // Check if phone number has the correct length
    const phoneDigits = this.state.phone.replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      alert("Lütfen geçerli bir telefon numarası giriniz (5XX XXX XX XX)");
      return;
    }

    // Continue with form submission
    // You can add your form submission logic here

    // Uncomment to submit the form
    // document.getElementById("contact-form").submit();
  };
  componentDidMount() {
    this.getIlan();
    this.getFeatured();
  }
  render() {
    return (
      <>
        <Loader />
        <SubHeader />
        <Header />
        <MainBanner />
        <RbaMapComponent />
        <div className="video section">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 offset-lg-4">
                <div className="section-heading text-center">
                  <h6 style={{ color: "white" }}>RBA Gayrimenkul</h6>
                  <h2>Gayrimenkulde Yeni Bir Bakış!</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="video-content mt-3">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                {/* Eski içerik yerine şimdi YouTube Player kullanıyoruz */}
                <YouTubePlayer
                  //youtubeUrl={"https://www.youtube.com/watch?v=CZEZ5r71arM"}
                  youtubeUrl={
                    "https://youtu.be/wYR65pGc3Jc?si=drpwcnP83xQw4-is"
                  } //erkan abi shorts
                />
              </div>
            </div>
          </div>
        </div>

        <div className="fun-facts">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wrapper">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="counter">
                        <h2
                          className="timer count-title count-number"
                          data-to="34"
                          data-speed="1000"
                        >
                          3000+
                        </h2>
                        <p className="count-text ">
                          Mutlu
                          <br />
                          Müşteri
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="counter">
                        <h2
                          className="timer count-title count-number"
                          data-to="12"
                          data-speed="1000"
                        >
                          17+
                        </h2>
                        <p className="count-text ">
                          Yıllık
                          <br />
                          Deneyim
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="counter">
                        <h2
                          className="timer count-title count-number"
                          data-to="24"
                          data-speed="1000"
                        >
                          %100
                        </h2>
                        <p className="count-text ">
                          Müşteri
                          <br />
                          Memnuniyeti
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.featured.length > 0 && (
          <BestDeals featured={this.state.featured} />
        )}

        {this.state.properties.length > 0 && (
          <div className="properties section">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 offset-lg-4">
                  <div className="section-heading text-center">
                    <h6>İLANLARIMIZ</h6>
                    <h2>Sizin İçin En İyi ve En Güncel İlanlar</h2>
                  </div>
                </div>
              </div>
              <div className="row properties-box">
                <this.PropertyListings />
              </div>
            </div>
          </div>
        )}

        <div className="contact section">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 offset-lg-4">
                <div className="section-heading text-center">
                  <h6>BİZİMLE İLETİŞİME GEÇ</h6>
                  <h2>Danışmanlarımızla İletişime Geçin</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div id="map">
                  <img
                    src="./Assets/Images/handshake.jpg"
                    style={{
                      border: "0",
                      borderRadius: "10px",
                      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
                    }}
                    // height="520px"
                    alt=""
                  />
                  {/* <iframe
                    src="https://www.google.com/maps/d/u/0/embed?mid=106yIwY6s3HCLjfTaraD1a16_5PBNMas&ehbc=2E312F"
                    width="100%"
                    height="520px"
                    frameBorder="0"
                    style={{
                      border: "0",
                      borderRadius: "10px",
                      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
                    }}
                    allowFullScreen=""
                    title="GoogleMap-abc"
                  ></iframe> */}
                </div>
                <div className="row mb-3">
                  <div className="col-lg-6">
                    <div className="item phone">
                      <img
                        src="../Assets/Images/phone-icon.png"
                        alt="Telefon İkonu"
                        style={{ maxWidth: "60px" }}
                      />
                      <h6>
                        0 544 830 91 30 <br />
                        0 222 222 0 722
                        <br />
                        <span>Telefon Numaramız</span>
                      </h6>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div
                      className="item email h-100"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <img
                        src="../Assets/Images/email-icon.png"
                        alt=""
                        style={{ maxWidth: "70px" }}
                      />
                      <div>
                        <h6
                          style={{
                            margin: "0",
                            wordBreak: "break-word",
                            fontSize: "18px",
                          }}
                        >
                          erkanbuyukarslan@hotmail.com
                          <br />
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#999",
                              fontWeight: "normal",
                            }}
                          >
                            Email Adresimiz
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <ContactForm></ContactForm>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/isotope.min.js"></script>
        <script src="assets/js/owl-carousel.js"></script>
        <script src="assets/js/counter.js"></script>
        <script src="assets/js/custom.js"></script>
      </>
    );
  }
}
